module.exports = __webpack_public_path__ + "static/media/evoUSDT.a514abc6.svg";